import React from "react"
import { channelsDef } from "./channels.def"
import { cn } from "lib/utils"

interface ChannelIconProps {
  channelCode: string | number
  size?: "xl" | "lg" | "md" | "sm" | "xs"
}

export const ChannelIcon = (props: ChannelIconProps) => {
  const channelDef = channelsDef.recordByCode[props.channelCode?.toString() || ""]
  return (
    <div
      className={cn(
        "size-9 text-xl aspect-square",
        props.size === "xl" && "size-9 text-xl",
        props.size === "lg" && "size-7 text-lg",
        props.size === "sm" && "size-6 text-2sm [&_.aspect-square]:p-[3px]",
      )}
    >
      {channelDef?.icon}
    </div>
  )
}
